import Link from "next/link";

// ── Badge ────────────────────────────────────────────────────────
export function Badge({
  count,
  color = "teal",
}: {
  count: number;
  color?: "teal" | "red";
}) {
  if (!count || count <= 0) return null;
  return (
    <span
      style={{ fontSize: 9 }}
      className={`absolute -top-1.5 -right-1.5 min-w-4 h-4 px-1 font-bold leading-none rounded-full flex items-center justify-center
        ${
          color === "red"
            ? "bg-rose-500 text-white"
            : "bg-emerald-500 text-white"
        }
      `}
    >
      {count > 99 ? "99+" : count}
    </span>
  );
}

// ── IconBtn ──────────────────────────────────────────────────────
export function IconBtn({
  href,
  onClick,
  badge,
  badgeColor,
  children,
  label,
}: {
  href?: string;
  onClick?: () => void;
  badge?: number;
  badgeColor?: "teal" | "red";
  children: React.ReactNode;
  label: string;
}) {
  const cls = `relative flex items-center justify-center w-9 h-9 rounded-2xl bg-white/[0.06] hover:bg-white/[0.12] border border-white/[0.09] hover:border-white/[0.18] text-white/60 hover:text-white transition-all duration-150 hover:scale-105 active:scale-95 cursor-pointer select-none`;

  const inner = (
    <span className={cls} aria-label={label}>
      {children}
      {badge !== undefined && <Badge count={badge} color={badgeColor} />}
    </span>
  );

  if (href) return <Link href={href}>{inner}</Link>;
  return (
    <button type="button" onClick={onClick} className="outline-none">
      {inner}
    </button>
  );
}

export const convertToArabicDate = (dateString: string | Date): string => {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return "تاريخ غير صالح";
  }

  return new Intl.DateTimeFormat("ar-EG", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);
};
